import React from 'react';
import { Navigate } from 'react-router-dom';

const DefaultRoute: React.FC = () => {
  const apiKey = localStorage.getItem('apiKey');
  // If not found any apiKey, redirect to the login page
  if (!apiKey) {
    return <Navigate to='/login' replace />;
  }

  return <Navigate to={'/'} replace />;
};

export default DefaultRoute;
